module.exports = __webpack_public_path__ + "img/8.11786ea8.png";